export enum HandlerType {
  sentry = 'sentry',
  console = 'console',
}
